import { borderRadius, color, fontSize, space } from '@core-ds/primitives';
import styled from 'styled-components';

export const Button = styled.button`
   display: 'inline-block';
   font-size: ${fontSize.lg};
   margin: 5px;
   padding: ${space[2]} ${space[3]};
   cursor: pointer;
   background: ${color.blue[500]};
   &:hover {
      background: ${color.blue[600]};
   }
   border-radius: ${borderRadius.md};
   color: ${color.white};
   opacity: ${({ disabled }) => (disabled ? '0.5' : '1')}
   pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')}
`;
